import { GenericObjectArrayType } from "../types/common";
export const CONST_CREDENTIALS_KEY = "DGD^#&#^#*#&#*(^GDGE#^*&*%%%";

export const colors = {
  THEME_COLOR: "#364174",
  BUTTON: "#009a44",
  WHITE: "#ffffff",
};

export const IDLE_TIMEOUT = 60 * 60 * 1000;
export const LAST_ACTIVE_KEY = "last_active_at";

export const BOOLEAN_OPTIONS: GenericObjectArrayType[] = [
  { id: 0, name: "False" },
  { id: 1, name: "True" },
];

export const BOOLEAN_SELECTIONS: GenericObjectArrayType[] = [
  { id: false, name: "No" },
  { id: true, name: "Yes" },
];

export const GENDER_SELECTIONS: GenericObjectArrayType[] = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
];

export const PAYMENT_METHODS: GenericObjectArrayType[] = [
  { id: "cash", name: "Cash" },
  { id: "cheque", name: "Cheque" },
  { id: "yoya_pay", name: "YOYA Pay" },
  { id: "bank_transfer", name: "Bank Transfer" },
  { id: "mobile_money", name: "Mobile Money" },
  { id: "credit_card", name: "Credit Card" },
];

export const FEW_PAYMENT_METHODS: GenericObjectArrayType[] = [
  { id: "mtn_momo", name: "MTN Momo" },
  { id: "airtel_pay", name: "Airtel Pay" },
  { id: "stanbic_bank", name: "Stanbic Bank" },
];

export const MALE = "Male";
export const FEMALE = "Female";

// Document type
export const DOC_TYPE_REPORT = "report";
export const DOC_TYPE_OTHER = "other";
export const RECONCILAITION_DOC_TYPE = "statement_file";
export const DOC_TYPE_ATTACHMENT = "attachment";

// DATE FORMATS
export const DATE_FORMAT = "DD-MM-YYYY";
export const DATE_YEAR = "YYYY";
export const DATE_TIME_FORMAT = "DD-MM-YYYY, hh:mm A";

// STATUS
export const PENDING = "pending";
export const PENDING_APPROVAL = "pending_approval";
export const PENDING_REVIEW = "pending_review";
export const SUBMITTED = "submitted";
export const REJECTED = "rejected";
export const DELIVERED = "delivered";
export const APPROVED = "approved";
export const CLAMPED = "clamped";
export const UNCLAMPED = "unclamped";
export const NOTIFIED = "notified";
export const VERIFIED = "verified";
export const DEFERRED = "deferred";
export const FORWARD = "forward";
export const CONFIRMED = "confirmed";
export const PAID_ADVANCE = "paid";
export const FOWARDED = "fowarded";
export const DISBURSED = "disbursed";
export const CLOSED = "closed";
export const ACTION_APPROVE = "approve";
export const ACTION_REJECT = "reject";

//Configurables
export const CAR_SIZE = "car_size";
export const COUPON_STRIP_AMOUNT = "coupon_strip_amount";
export const RESERVATION_TYPE = "reservation_type";
export const STICKER_TYPE = "sticker_type";
export const STICKER_TYPES = "sticker_types";
export const BOOKING_TYPE_CONFIGURABLE = "booking_type_configurable";
export const BOOKING_TYPE_CONFIGURABLES = "booking_type_configurables";

// LABELS
export const VIEW = "View";
export const EDIT = "Edit";
export const RENEW = "Renew";
export const DELETE = "Delete";
export const DEACTIVATE = "Deactivate";
export const ACTIVATE = "Activate";
export const REACTIVATE = "Reactivate";
export const CLOSE = "Close";
export const APPROVE = "Approve";
export const REQUEST_REVERSE = "Request Reversal";
export const REJECT = "Reject";
export const CLAMP = "Clamp";
export const UNCLAMP = "Unclamp";
export const REQUEST_ADVANCE = "Request Advance";
export const REQUEST_REQUISITION = "Request Requisition";

// MASTER DATA TYPES
export const DISTRICT = "district";
export const PARISH = "parish";
export const COUNTY = "county";
export const SUB_COUNTY = "sub_county";
export const VILLAGE = "village";

export const CASH = "CASH";
export const MOBILE_MONEY = "MOT";
export const COUPON = "COUPON";

//Plurals
export const DISTRICTS = "districts";
export const COUNTIES = "counties";
export const SUB_COUNTIES = "sub_counties";
export const PARISHES = "parishes";
export const VILLAGES = "villages";

export const STREETS = "streets";
export const STREET = "street";

export const PARKING = "parking_yard";
export const PARKINGS = "parking_yards";

export const PAYMENT_MODE = "payment_mode";
export const PAYMENT_MODES = "payment_modes";

export const TELECOM_NETWORK_CODE = "telecom_code";
export const TELECOM_NETWORK_CODES = "telecom_codes";

export const PARKED_CAR = "parked_car";
export const PARKED_CARS = "parked_cars";

export const CURRENTLY_PARKED_CAR = "currently_parked_car";
export const CURRENTLY_PARKED_CARS = "currently_parked_cars";

export const PARKED_CARS_SERVICES = "parked_cars_services";
export const PARKED_CARS_SERVICES_PAGINATED = "parked_cars_services_paginated";

export const PARKING_RATE = "parking_rate";
export const PARKING_RATES = "parking_rates";

export const SLOT = "slot";
export const SLOTS = "slots";

export const RESERVED_BOOKINGS = "reserved_bookings";
export const RESERVED_BOOKING = "reserved_booking";

export const CLAMPING = "clamping";
export const CLAMPINGS = "clampings";

export const STICKER_BOOKINS = "sticker_bookings";
export const STICKER_BOOKING = "sticker_booking";

export const ADVANCE_BOOKINGS = "advance_bookings";
export const ADVANCE_BOOKING = "advance_booking";

export const APPROVED_BOOKINGS = "approved_bookings";
export const APPROVED_BOOKING = "approved_booking";

export const REJECTED_BOOKINGS = "rejected_bookings";
export const REJECTED_BOOKING = "rejected_booking";

export const SUBMITTED_BOOKINGS = "submmitted_bookings";
export const SUBMITTED_BOOKING = "submmitted_booking";

export const ALL_BOOKINGS = "bookings";
export const ALL_BOOKING = "booking";

export const BOOKING_RESERVATION_RATES = "booking_rates";
export const BOOKING_RESERVATION_RATE = "booking_rate";

export const PAYMENT_REQUESTS = "payment_request";
export const PAYMENT_REQUEST = "payment_reques";

export const PAID_REQUESTS = "paid_requests";
export const PAID_REQUEST = "paid_request";

export const BILLING_INVOICES = "billing_invoices";
export const BILLING_INVOICE = "billing_invoice";

export const CAR_SLOT_MAPPINGS = "car_slot_mappings";
export const CAR_SLOT_MAPPING = "car_slot_mapping";

export const ADVANCE_BALANCE = "advance_balances";
export const ADVANCE_BALANCES = "advance_balance";

export const ADVANCES_TRANSACTION = "advances_transaction";
export const ADVANCES_TRANSACTIONS = "advances_transactions";

export const LINKED_CARS = "linked_cars";
export const LINKED_CARS_PAGINATED = "linked_cars_paginated";

export const PENALTY_SETTING = "penalty_setting";
export const PENALTY_SETTINGS = "penalty_settings";

export const SERVICE_RATE = "service_rate";
export const SERVICE_RATES = "service_rates";

export const SERVICE_TYPE = "service_type";
export const SERVICE_TYPES = "service_types";

export const SURCHARGE_CONFIGURABLE = "surcharge_configurable";
export const SURCHARGE_CONFIGURABLES = "surcharge_configurables";

export const SURCHARGE = "surcharge";
export const SURCHARGES = "surcharges";

export const RECONCILIATION_ERROR_LOGS = "reconciliation_error_logs";
export const RECONCILIATION_ERROR_LOG = "reconciliation_error_log";

export const STATEMENT_LOGS = "statement_logs";
export const STATEMENT_LOG = "statement_log";

export const RECONCILAITION = "reconcilation";
export const RECONCILAITIONS = "reconcilations";

export const SYSTEM_ACCOUNT = "system_account";
export const SYSTEM_ACCOUNTS = "system_accounts";

export const LIQUIDATION_REQUESTS = "liquidation_requests";
export const LIQUIDATION_REQUEST = "liquidation_request";

export const WAGES_REPORT = "wages_report";
export const WAGES_REPORTS = "wages_reports";

// PROFILE
export const PROFILE = "profile";
export const USERS = "users";

// Permissions
export const CAN_VIEW_SYSTEM_SETTINGS = "can_view_system_settings";
export const CAN_EDIT_SYSTEM_SETTINGS = "can_edit_system_settings";
export const CAN_EDIT_USERS = "can_edit_users";
export const CAN_ADD_LOAN_USER = "add_yoyaloanuser";
export const CAN_CHANGE_LOAN_USER = "change_yoyaloanuser";
export const CAN_DELETE_LOAN_USER = "delete_yoyaloanuser";
export const CAN_VIEW_LOAN_USER = "view_yoyaloanuser";
export const CAN_VIEW_REPORTS = "can_view_reports";
export const CAN_PUBLIC = "can_public";
export const CAN_MANAGE_CHARTS_OF_ACCOUNTS = "can_manage_chart_of_accounts";
export const CAN_AGENT = "can_agent";

// Application permissions
export const CAN_VIEW_SUBMITTED_APPLICATIONS =
  "can_view_submitted_applications";
export const CAN_VIEW_APPROVED_APPLICATIONS = "can_view_approved_applications";
export const CAN_VIEW_RECOMMENDED_APPLICATIONS =
  "can_view_recommended_applications";
export const CAN_APPROVE_APPLICATION = "can_approve_application";
export const CAN_REJECT_APPLICATION = "can_reject_application";
export const CAN_DEFER_APPLICATION = "can_defer_application";
export const CAN_RECOMMEND_APPLICATION = "can_recommend_application";
export const CAN_REVIEW_APPLICATION = "can_review_application";
export const CAN_ADD_APPLICATION = "can_add_application";
export const CAN_SPECIAL_EDIT = "can_special_edit";
export const CAN_MAKE_PAYMENTS = "can_make_payments";

// Wages
export const CAN_APPROVE_STAFF_WAGES_REQUISITION =
  "can_approve_staff_wages_requisition";
export const CAN_HEAD_ACCOUNTANT_REVIEW_STAFF_WAGES_REQUISITION =
  "can_head_accountant_review_staff_wages_requisition";
export const CAN_REVIEW_STAFF_WAGES_REQUISITION =
  "can_review_staff_wages_requisition";
export const CAN_APPROVE_PETTY_CASH_REQUISITION =
  "can_approve_petty_cash_requisition";
export const CAN_HEAD_ACCOUNTANT_REVIEW_PETTY_CASH_REQUISITION =
  "can_head_accountant_review_petty_cash_requisition";
export const CAN_REVIEW_PETTY_CASH_REQUISITION =
  "can_review_petty_cash_requisition";

// Organisation permissions
export const CAN_ADD_ORGANISATION = "can_add_organisation";

// Payroll permissions
export const CAN_CREATE_PAYROLL = "can_process_payroll";
export const CAN_REVIEW_PAYROLL = "can_review_payroll";
export const CAN_APPROVE_PAYROLL = "can_approve_payroll";
export const CAN_ACCESS_PAYROLL_MODULE = "can_access_payroll_module";
export const CAN_EDIT_PAYROLL = "can_update_payroll_data";
export const CAN_ADD_INVENTORY_CHECKLIST = "can_add_inventory_checklist";

// Inventory permissions
export const CAN_SUBMIT_PURCHASE_ORDER = "can_submit_purchase_order";
export const CAN_VIEW_PURCHASE_ORDER = "can_view_submitted_register";
export const CAN_APPROVE_PURCHASE_ORDER = "can_approve_purchase_order";
export const CAN_EDIT_PURCHASE_ORDER = "can_review_submitted_purchase_order";
export const CAN_VIEW_SUBMITTED_REGISTER = "can_view_submitted_register";
export const CAN_SUBMIT_RECEIVE_INVENTORY_CHECKLIST =
  "can_submit_receive_inventory_checklist";
export const CAN_EDIT_RECEIVED_INVENTORY_CHECKLIST =
  "can_review_received_inventory_checklist";

// User Management Permissions
export const CAN_ADD_ROLES = "can_add_roles";
export const CAN_CREATE_PERMISSIONS = "can_create_permissions";
export const CAN_ASSIGN_PERMISSIONS = "can_assign_permissions";
export const CAN_EDIT_ROLES = "can_edit_roles";
export const CAN_EDIT_PERMISSIONS = "can_edit_permissions";
export const CAN_ADD_USERS = "can_add_users";
export const CAN_VIEW_USERS = "can_view_users";
export const CAN_DEACTIVATE_USERS = "can_deactivate_users";
export const CAN_REACTIVATE_USERS = "can_reactivate_users";
export const CAN_ASSIGN_USER_ROLES = "can_assign_user_roles";
export const CAN_EDIT_USER_PROFILE = "can_edit_user_profile";

// Agent and Staff Management Permissions
export const CAN_ADD_AGENTS = "can_add_agents";
export const CAN_ADD_STAFF = "can_add_staff";
export const CAN_VIEW_AGENTS = "can_view_agents";
export const CAN_VIEW_STAFF = "can_view_staff";
export const CAN_EDIT_AGENT_DETAILS = "can_edit_agent_details";
export const CAN_EDIT_STAFF_DETAILS = "can_edit_staff_details";
export const CAN_DEACTIVATE_AGENTS_AND_STAFF =
  "can_deactivate_agents_and_staff";
export const CAN_VIEW_AGENT_LOGS = "can_view_agent_logs";
export const CAN_VIEW_AGENT_ACCOUNT_BALANCE = "can_view_agent_account_balance";

// System Settings Permissions
export const CAN_ADD_SYSTEM_SETTINGS = "can_add_system_settings";
export const CAN_ADD_VIEW_EDIT_DELETE_CHART_OF_ACCOUNTS =
  "can_add_view_edit_delete_chart_of_accounts";
export const CAN_ADD_VIEW_EDIT_DELETE_PAYMENT_MODES =
  "can_add_view_edit_delete_payment_modes";
export const CAN_ADD_VIEW_EDIT_DELETE_TELECOM_CODES =
  "can_add_view_edit_delete_telecom_codes";
export const CAN_ADD_VIEW_EDIT_DELETE_TELECOM_CHARGES =
  "can_add_view_edit_delete_telecom_charges";
export const CAN_ADD_VIEW_EDIT_DELETE_WORKFLOWS =
  "can_add_view_edit_delete_workflows";
export const CAN_ADD_VIEW_EDIT_DELETE_MASTER_DATA =
  "can_add_view_edit_delete_master_data";

// Parking Management Permissions
export const CAN_ASSIGN_REASSIGN_PARKING_YARDS =
  "can_assign_reassign_parking_yards";
export const CAN_ADD_VIEW_EDIT_DELETE_PARKING_YARDS =
  "can_add_view_edit_delete_parking_yards";
export const CAN_ADD_VIEW_EDIT_DELETE_PARKING_SLOTS =
  "can_add_view_edit_delete_parking_slots";
export const CAN_ADD_VIEW_EDIT_DELETE_PARKING_RATES =
  "can_add_view_edit_delete_parking_rates";
export const CAN_ADD_VIEW_EDIT_DELETE_FEES_PAYMENT_INTERVAL =
  "can_add_view_edit_delete_fees_payment_interval";
export const CAN_ADD_VIEW_EDIT_DELETE_FEES_AMOUNT =
  "can_add_view_edit_delete_fees_amount";
export const CAN_ADD_VIEW_EDIT_DELETE_VEHICLE_SIZE =
  "can_add_view_edit_delete_vehicle_size";
export const CAN_ADD_VIEW_EDIT_DELETE_RESERVATION_RATES =
  "can_add_view_edit_delete_reservation_rates";
export const CAN_VIEW_PARKED_CARS = "can_view_parked_cars";
export const CAN_ENFORCE = "can_enforce";
export const CAN_MANAGE_PARKING = "can_manage_parking";
export const CAN_SEARCH_FOR_PARKING_SLOT = "can_search_for_parking_slot";
export const CAN_NAVIGATE_TO_PARKING_SLOT = "can_navigate_to_parking_slot";
export const CAN_VIEW_PARKING_LIST = "can_view_parking_list";

// Reporting Permissions
export const CAN_VIEW_SYSTEM_LOGS = "can_view_system_logs";
export const CAN_VIEW_AUDIT_TRAIL = "can_view_audit_trail";
export const CAN_VIEW_MONITORING_REPORTS = "can_view_monitoring_reports";
export const CAN_VIEW_CHART_OF_ACCOUNTS_REPORTS =
  "can_view_chart_of_accounts_reports";
export const CAN_VIEW_LEDGER_REPORTS = "can_view_ledger_reports";
export const CAN_VIEW_REVENUE_PERFORMANCE_REPORTS =
  "can_view_revenue_performance_reports";
export const CAN_VIEW_PARKING_SLOT_OCCUPANCY_REPORTS =
  "can_view_parking_slot_occupancy_reports";
export const CAN_VIEW_DEFAULTERS_REPORTS = "can_view_defaulters_reports";
export const CAN_VIEW_PAYMENTS_REPORTS = "can_view_payments_reports";
export const CAN_VIEW_GENERAL_LEDGER = "can_view_general_ledger";
export const CAN_VIEW_PAYMENTS_REGISTER = "can_view_payments_register";
export const CAN_VIEW_INVOICES = "can_view_invoices";
export const CAN_VIEW_PAYMENT_REQUESTS = "can_view_payment_requests";
export const CAN_VIEW_DASHBOARD = "can_view_dashboard";

// Booking Management Permissions
export const CAN_INITIATE_RESERVATION = "can_initiate_reservation";
export const CAN_APPROVE_RESERVATION = "can_approve_reservation";
export const CAN_REJECT_RESERVATION = "can_reject_reservation";
export const CAN_VIEW_SUBMITTED_BOOKINGS = "can_view_submitted_bookings";
export const CAN_VIEW_APPROVED_BOOKINGS = "can_view_approved_bookings";
export const CAN_VIEW_REJECTED_BOOKINGS = "can_view_rejected_bookings";
export const CAN_VIEW_ADVANCED_BOOKINGS = "can_view_advanced_bookings";
export const CAN_VIEW_STICKER_BOOKINGS = "can_view_sticker_bookings";
export const CAN_MAKE_AN_ADVANCE_PAYMENT = "can_make_an_advance_payment";
export const CAN_RECONCILE = "can_reconcile";
export const CAN_VIEW_COUPON_SALES_REPORTS = "can_view_coupon_sales_reports";
export const CAN_APPROVE_LIQUIDATION_REQUEST =
  "can_approve_liquidation_request";

// Wage Advancement Permissions
export const CAN_INITIATE_WAGE_ADVANCEMENT = "can_initiate_wage_advancement";
export const CAN_REVIEW_WAGE_ADVANCEMENT = "can_review_wage_advancement";
export const CAN_HR_REVIEW_WAGE_ADVANCEMENT = "can_hr_review_wage_advancement";
export const CAN_APPROVE_WAGE_ADVANCEMENT = "can_approve_wage_advancement";

// Asset Management Permissions
export const CAN_VIEW_ASSETS = "can_view_assets";
export const CAN_REGISTER_ASSETS = "can_register_assets";
export const CAN_EDIT_ASSETS = "can_edit_assets";
export const CAN_TRANSFER_ASSETS = "can_transfer_assets";
export const CAN_APPROVE_ASSET_TRANSFER = "can_approve_asset_transfer";
export const CAN_UPDATE_ASSET_STATUS = "can_update_asset_status";
export const CAN_PERFORM_ASSET_STOCK_COUNT = "can_perform_asset_stock_count";
export const CAN_APPROVE_ASSET_STOCK_COUNT = "can_approve_asset_stock_count";
export const CAN_DISPOSE_ASSETS = "can_dispose_assets";
export const CAN_APPROVE_ASSET_DISPOSAL = "can_approve_asset_disposal";
export const CAN_VIEW_ASSET_REPORTS = "can_view_asset_reports";
export const CAN_CONFIGURE_ASSET_SYSTEM = "can_configure_asset_system";

// Deployment Permissions
export const CAN_DEPLOY_USERS = "can_deploy_users";
export const CAN_MANAGE_ENFORCEMENT_TEAMS = "can_manage_enforcement_teams";
export const CAN_VIEW_ENFORCEMENT_TEAM_DETAILS =
  "can_view_enforcement_team_details";
export const CAN_VIEW_ALL_DEPLOYMENTS = "can_view_all_deployments";
export const CAN_VIEW_SUPERVISED_DEPLOYMENTS =
  "can_view_supervised_deployments";
export const CAN_VIEW_OWN_DEPLOYMENT = "can_view_own_deployment";
export const CAN_COMMENT_ON_DEPLOYMENTS = "can_comment_on_deployments";
export const CAN_VIEW_DEPLOYMENT_COMMENTS = "can_view_deployment_comments";

// Vehicle Management Permissions
export const CAN_ADD_VEHICLE = "can_add_vehicle";

// Purchase order permissions
export const CAN_ADD_PRODUCT_TO_PURCHASE_ORDERS = "can_add_product_to_orders";

export const APPLICATIONS_ACTIONS = [
  CAN_APPROVE_APPLICATION,
  CAN_REJECT_APPLICATION,
  CAN_RECOMMEND_APPLICATION,
  CAN_REVIEW_APPLICATION,
];

// TYPES
export const SELECT = "select";
export const MODAL = "modal";
export const TEXT = "text";

// Loan application types
export const NEW_APPLICANT = "New Applicant";
export const EXISTING_APPLICANT = "Existing Applicant";
export const MIGRATED_APPLICANT = "Migrated Applicant";
export const RESTRUCTURED_APPLICANT = "Restructured Applicant";

// SOURCES
export const LOAN_APPLICATION = "loan_application";

export const FORM_DATA = "multipart/form-data";

// CONFIGURABLES
export const MOTORCYCLE_TYPE = "motorcycle-type";
export const VEHICLE_TYPE = "vehicle-type";
export const CATEGORY_INVENTORY_TYPE = "inventory-category";
export const INCOME_TYPE = "income-type";
export const EXPENSE_TYPE = "expense-type";
// FILE EXTENSIONS
export const FILE_TYPE_DOC = "doc";
export const FILE_TYPE_DOCX = "docx";
export const FILE_TYPE_JPG = "jpg";
export const FILE_TYPE_JPEG = "jpeg";
export const FILE_TYPE_PNG = "png";
export const FILE_TYPE_PDF = "pdf";

// data view
export const DEFAULT_EXCLUDED = [
  "id",
  "declaration",
  "created_at",
  "updated_at",
  "deleted",
];

// Salary component
export const BASE_SALARY = "base_salary";
export const ALLOWANCE = "allowance";
export const BONUS = "bonus";

// Adhoc Reports
const TODAY = "today";
const YESTERDAY = "yesterday";
const THIS_WEEK = "this_week";
const LAST_WEEK = "last_week";
const THIS_MONTH = "this_month";
const LAST_MONTH = "last_month";
const THIS_YEAR = "this_year";
const LAST_YEAR = "last_year";
const THIS_FY = "this_fy";
const LAST_FY = "last_fy";

export const START_DATE_FILTER = "created_at_min_date";
export const END_DATE_FILTER = "created_at_max_date";

export const preFilters = [
  TODAY,
  YESTERDAY,
  THIS_WEEK,
  LAST_WEEK,
  THIS_MONTH,
  LAST_MONTH,
  THIS_YEAR,
  LAST_YEAR,
  THIS_FY,
  LAST_FY,
];

export const CONST_PAYMENTS_ADHOC = "payments";
export const CONST_PARKED_CARS_ADHOC = "parked_cars";
export const CONST_BOOKING_REPORT_ADHOC = "booking_reports";
export const CONST_INVOICES_REPORT_ADHOC = "invoices_reports";
export const CONST_ECOUPON_REPORT_ADHOC = "ecoupon_reports";

export const LOAN_APPLICATIONS = "loan-applications";
export const PURCHASE_ORDERS = "purchase-orders";
export const AGEING_REPORT = "debtors_aging_report";
export const AGENT_PERFORMANCE_REPORTS = "agent_perfomance_report";

export const AGEING_REPORT_ADHOC_API = "reports/debtors-ageing-report-adhoc/";
export const LEDGER_REPORT_ADHOC_API = "accountings/ledgers-adhoc/";
export const LOAN_REPAYMENTS = "loan-repayments";
export const LEDGER_REPORT = "ledger-report";

export const PARKING_SLOTS_OCCUPANCY_API = "reports/parking-slot-occupancy/";
export const BOOKING_ADHOC_API = "bookings-adhoc/";
export const PARKED_CARS_ADHOC_API = "parked-cars-adhoc/";
export const INVOICES_ADHOC_API = "billings/invoices-adhoc/";
export const ECOUPON_ADHOC_API = "advance-transactions-adhoc/";

export const REVENUE_PERFORMANCE_ADHOC_API = "reports/revenue-performance/";
export const PAYMENTS_ADHOC_API = "payments-adhoc/";
export const PAYMENTS_REPORT_API = "reports/payments/";
export const AGING_REPORT_API = "reports/debtors-aging/";
export const END_OF_DAY_REPORT_API = "end-of-day/";
export const DAILY_COLLECTION_BALNCES_API = "daily-collection-balances/";
export const API_REVENUE_LEDGER_REPORTS = "revenue-ledger/";
export const API_AGENT_PERFORMANCE_REPORTS = "reports/agent-performance/";
export const API_REVENUE_PERFORMANCE_SOURCE_REPORTS =
  "get-revenue-performance/";

export const API_AGENT_DEPOSIT_PERFORMANCE_REPORTS = "agent-deposits/";

export const API_AGENT_DEFAULTER_PERFORMANCE_REPORTS = "defaulter-agents/";
export const API_COUPON_SALES_REPORTS = "reports/coupon-sales/";

export const CONST_MODULES = [
  {
    value: CONST_BOOKING_REPORT_ADHOC,
    label: "Booking Report",
    api: `/bookings-adhoc/`,
  },
  {
    value: CONST_PARKED_CARS_ADHOC,
    label: "Parked Cars",
    api: `/parked-cars-adhoc/`,
  },
  {
    value: CONST_PAYMENTS_ADHOC,
    label: "Payments",
    api: `/payments-adhoc/`,
  },

  {
    value: CONST_INVOICES_REPORT_ADHOC,
    label: "Invoices",
    api: `/invoices-adhoc/`,
  },
  {
    value: CONST_ECOUPON_REPORT_ADHOC,
    label: "E-Coupons",
    api: `/advance-transactions-adhoc/`,
  },
];

export const APP_NAME = "Smart Parking";
export const APP_ORGANIZATION = "YOYA Technologies";

export const RESERVATION = "reservation";
export const STICKER = "sticker";
export const ADVANCE = "advance";
export const INDIVIDUAL = "individual";
export const ORGANISATION = "organisation";
export const ALL_SYSTEM_BOOKINGS = "all_bookings";

export const ATTACHMENTS = "attachments";

export const DAILY = "DAILY";
export const WEEKLY = "WEEKLY";
export const MONTHLY = "MONTHLY";

// NEGOTIATED PAYMENT PERMISSIONS
export const CAN_APPROVE_NEGOTIATED_PAYMENT = "can_approve_negotiated_payment";
export const CAN_MAKE_FULL_PAYMENTS = "can_make_full_payments";
export const CAN_REQUEST_NEGOTIATED_PAYMENT = "can_request_negotiated_payment";
export const CAN_MAKE_PARTIAL_PAYMENTS = "can_make_partial_payments";

//PAY WEEK CONFIGURATION
export const isDay = (day: any) =>
  day !== undefined && day !== null && day !== "";

export const payWeekLength = (start: any, end: any) =>
  ((Number(end) - Number(start) + 7) % 7) + 1;

const SUNDAY = 6;

export const spansSunday = (start: any, end: any) =>
  (SUNDAY - Number(start) + 7) % 7 < payWeekLength(start, end);
